<template>
  <div class="mobileViewStyle solution-detail">
    <!-- 推荐方案详情（企业微信手机端，仅查看）：只展示方案本身，不展示方案与客户的关联 -->
    <div class="detail-body" v-loading="loading">
      <list-card :label="detail.solutionName || '推荐方案'">
        <template #desc>
          <span class="type-tag">{{ Number(detail.solutionType) === 2 ? "定制方案" : "通用方案" }}</span>
        </template>
        <data-column label="方案名称">{{ detail.solutionName || "—" }}</data-column>
        <data-column label="方案类型">{{ Number(detail.solutionType) === 2 ? "定制方案" : "通用方案" }}</data-column>
        <data-column label="推荐规则">{{ ruleName(detail.solutionRule) || "—" }}</data-column>
        <data-column label="方案描述">{{ detail.solutionDesc || "—" }}</data-column>
        <data-column label="创建时间">{{ dateTime(detail.createdTime) }}</data-column>
      </list-card>

      <list-card class="rule-card" :label="'推荐明细（' + rules.length + '）'">
        <div v-if="rules.length === 0" class="empty">暂无推荐明细</div>
        <div class="rule-row" v-for="(item, index) in rules" :key="item.id || index">
          <div class="rule-index">{{ index + 1 }}</div>
          <div class="rule-info">
            <div class="line">
              <span class="label">回复商品</span>
              <span class="value">{{ item.solutionFromName || "—" }}</span>
            </div>
            <div class="line">
              <span class="label">推荐商品</span>
              <span class="value">{{ item.solutionToName || "—" }}</span>
            </div>
            <div class="line">
              <span class="label">推荐权重</span>
              <span class="value">{{ item.solutionWeight === null || item.solutionWeight === undefined ? 0 : item.solutionWeight }}</span>
            </div>
          </div>
        </div>
      </list-card>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import qywxXbotSolutionApi from "@/api/dz-ai/qywxXbotSolutionApi";

// 推荐规则（与 web 端 solutionRule.json 保持一致）
const RULE_LIST = [
  {name: "库存不足推荐", value: "STOCK"},
  {name: "一直推荐", value: "NAME"},
];

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "SolutionDetailQW",
  components: {
    DataColumn, ListCard
  },
  data() {
    return {
      loading: false,
      detail: {},
      ruleList: RULE_LIST,
    };
  },
  computed: {
    rules() {
      return this.detail.solutionRules || [];
    }
  },
  created() {
    const id = this.route.query.id;
    if (!id) {
      return;
    }
    this.loading = true;
    qywxXbotSolutionApi.findById(id).then(data => {
      this.detail = data || {};
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  },
  methods: {
    ruleName(value) {
      const rule = this.ruleList.find(r => r.value === value);
      return rule ? rule.name : "";
    },
    dateTime(value) {
      return value ? String(value).slice(0, 16) : "—";
    },
  }
};
</script>

<style lang="scss" scoped>
.solution-detail{
  height: 100%;
  overflow: auto;
  .detail-body{
    padding: 10px;
  }
  .type-tag{
    padding: 2px 8px;
    border-radius: 4px;
    font-size: var(--yq-font-size-mini-mobile);
    color: var(--el-color-primary);
    background: var(--el-color-primary-light-9);
  }
  .rule-card{
    display: block;
    margin-top: 10px;
    .empty{
      padding: 20px 0;
      text-align: center;
      font-size: var(--yq-font-size-mini-mobile);
      color: var(--yq-font-color-desc);
    }
    .rule-row{
      display: flex;
      gap: 10px;
      padding: 10px 0;
      border-bottom: 1px solid var(--yq-border-color);
      &:last-child{
        border-bottom: none;
      }
      .rule-index{
        flex: none;
        width: 22px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        border-radius: 50%;
        font-size: var(--yq-font-size-mini-mobile);
        color: #FFF;
        background: var(--el-color-primary);
      }
      .rule-info{
        flex: 1;
        min-width: 0;
        .line{
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 10px;
          line-height: 24px;
          font-size: var(--yq-font-size-mini-mobile);
          .label{
            flex: none;
            color: var(--yq-font-color-desc);
          }
          .value{
            flex: 1;
            min-width: 0;
            text-align: right;
            color: var(--yq-font-color-base);
            word-break: break-all;
          }
        }
      }
    }
  }
}
</style>
